import Vue from "vue";
import Vuex from "vuex";
// import { Message } from "element-ui";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cityList: {},
    unionInfo: {}
  },
  mutations: {
    setCityList(state, cityList) {
      state.cityList = cityList;
    },
    setUnionInfo(state, info) {
      state.unionInfo = info;
    }
  },
  actions: {}
});
